import { ChangeDetectionStrategy, Component, input, model, ViewEncapsulation, computed, output } from '@angular/core';
import { ITodoSection } from '@fi-app/fi-onboarding/fi-todo/fi-todo';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { IOnboardingCompletionUserStep, ITodoItemCompletion } from '../../../fi-onboarding-completion';
import { FiOnboardingCompletionStateType } from '../../../fi-onboarding-completion-enums';

@Component({
    selector: 'fi-todo-list-completion-section',
    templateUrl: './todo-list-completion-section.component.html',
    styleUrl: './todo-list-completion-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-list-completion-section' },
    standalone: false,
})
export class FiTodoListCompletionSectionComponent {
    public section = input.required<ITodoSection>();
    public userCompletionStep = model.required<IOnboardingCompletionUserStep>();
    public completedTodoItems = input.required<ITodoItemCompletion[]>();
    public nextStepCompletionState = input.required<FiOnboardingCompletionStateType>();
    public isTodoItemCompletionChanged = output<boolean>();

    protected onTodoItemCompletionChanged() {
        this.isTodoItemCompletionChanged.emit(true);
    }
}
